import styled from 'styled-components'


export const TableContainer = styled.div<{ windowWidth: number }>`
  font-size: ${({ windowWidth }) => (windowWidth < 470 ? '0.85em' : '1em')};
  min-height: 200px;
  margin: 16px 22px;
  padding: 24px;
  background: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px 0px,
    rgba(0, 0, 0, 0.23) 0px 3px 6px 0px;
  border-radius: 20px;
  margin-bottom: 70px;
`

export const TableRowHead = styled.tr`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  border-bottom: 1px solid #dddddd;
`

export const TableRowHeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const TableRowBody = styled.tr`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  border-bottom: 1px solid #dddddd;
  &:nth-child(even) {
    background-color: #fafafa;
  }
  &:nth-child(odd) {
    background-color: #ffffff;
  }
  &:hover {
    cursor: pointer;
    background: #f7f7f7;
  }
`

export const TableHeaderData = styled.td<{ width: number }>`
  font-weight: 700;
  display: table-cell;
  text-align: center;
  padding: ${({ width }) => (width < 600 ? '12px 4px' : '16px')};
  font-size: ${({ width }) => (width < 1140 ? '0.85em' : '1em')};
  word-break: break-word;
`

export const TableData = styled.td<{ width: number }>`
  display: table-cell;
  text-align: center;
  padding: ${({ width }) => (width < 600 ? '12px 4px' : '16px')};
  font-size: ${({ width }) => (width < 1140 ? '0.85em' : '1em')};
  word-break: break-word;
`


export const Input = styled.input`
  width: 50px;
  border: none;
  background: none;
  text-align: center;
  border-bottom: 1px solid #dddddd;
  &:focus {
    outline: none;
    border-bottom: 1px solid #2164db;
  }
`

export const CheckboxInput = styled.input<{ width: number }>`
  width: ${({ width }) => (width < 600 ? '14px' : '20px')};
  height: ${({ width }) => (width < 600 ? '14px' : '20px')};
  border: 1px solid #dddddd;
  background-color: #ffffff;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  margin: 8px;
  &:checked {
    background-color: #2164db;
    border-color: #2164db;
  }

  &:hover {
    cursor: pointer;
  }
`

export const NoDataText = styled.p`
  padding: 60px;
  text-align: center;
  margin: 10px;
  font-weight: 700;
  line-height: 1.5;
  font-size: 0.8em;
`
